import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  COORDINATION_GROUP,
  TStaffUserResponse,
} from "../../api/user/apiListStaffUsers";
import { TSelectGroupedOption } from "../../apps/affinity/pages/ServicePage/components/ServiceValuation/types";

export default function useCoordinationStaffOptions() {
  const [staff, setStaff] = useState<TSelectGroupedOption[]>([]);
  const staffState: TStaffUserResponse[] = useSelector((state: any) => {
    return state.usuariosState.staff;
  });

  useEffect(() => {
    const barcelona: TSelectGroupedOption = {
      label: "Barcelona",
      options: [],
    };
    const madrid: TSelectGroupedOption = {
      label: "Madrid",
      options: [],
    };
    const euskadi: TSelectGroupedOption = {
      label: "País Vasco",
      options: [],
    };
    const otherFast: TSelectGroupedOption = {
      label: "Otros rápido",
      options: [],
    };
    const otherSlow: TSelectGroupedOption = {
      label: "Otros lento",
      options: [],
    };
    const other: TSelectGroupedOption = {
      label: "Otros",
      options: [],
    };

    const sortedStaff = staffState.sort((a, b) => {
      if (a.fullname < b.fullname) {
        return -1;
      }
      return 1;
    });

    sortedStaff.forEach((item) => {
      if (!item.active) {
        return;
      }

      if (!item.enabled) {
        return;
      }

      let included = false;
      if (item.coordinationGroups?.includes(COORDINATION_GROUP.BCN)) {
        barcelona.options.push({
          value: item.id,
          label: item.fullname,
        });
        included = true;
      }
      if (item.coordinationGroups?.includes(COORDINATION_GROUP.MAD)) {
        madrid.options.push({
          value: item.id,
          label: item.fullname,
        });
        included = true;
      }
      /* if (item.coordinationGroups?.includes(COORDINATION_GROUP.CAV)) {
        euskadi.options.push({
          value: item.id,
          label: item.fullname,
        });
        included = true;
      } */
      if (item.coordinationGroups?.includes(COORDINATION_GROUP.OTH_FAST)) {
        otherFast.options.push({
          value: item.id,
          label: item.fullname,
        });
        included = true;
      }
      if (item.coordinationGroups?.includes(COORDINATION_GROUP.OTH_SLOW)) {
        otherSlow.options.push({
          value: item.id,
          label: item.fullname,
        });
        included = true;
      }
      if (!included) {
        other.options.push({
          value: item.id,
          label: item.fullname,
        });
      }
    });

    setStaff([barcelona, madrid, euskadi, otherFast, otherSlow, other]);
  }, [staffState, setStaff]);

  return staff;
}
